<template lang="pug">
.note
  p.section-title Note
  .panel(
    :class="!note ? 'empty' : ''"
    data-test-id="slidein-note"
    )
    p(
      v-if="note"
      ) {{ note }}
    p(
      v-else
      ) No note
</template>

<script>
export default {
  name: 'OverviewNote',
  props: {
    note: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="stylus" scoped>
.booking-card-overview .note .panel
  margin-bottom 0
  max-height 115px
  overflow-y scroll
</style>
